import React, { useMemo } from "react";
import { Avatar, Group, Text } from "@mantine/core";
import { ICellProps } from "ka-table/props";
import { useWorkspaceMembers } from "../../hooks/QueryHooks";
import useWorkspaceStore from "../../store/workspace/workspaceStore";

const SignalOwnerCell: React.FC<ICellProps> = ({
  column,
  rowData,
}) => {
  const workspace = useWorkspaceStore((state) => state.workspace);
  const { data: workspaceMembers }: any = useWorkspaceMembers({
    workspaceId: workspace?.id,
    enabled: !!workspace?.id,
    retry: 2,
  });

  const userId = rowData[`${column.key}`];
  
  const user = useMemo(() => {
    if (!userId || userId === "unassigned") {
      return { name: "Unassigned", value: "unassigned" };
    }
    
    return workspaceMembers?.users?.find((member: any) => member.user_id === userId) || { name: "Unknown" };
  }, [workspaceMembers?.users, userId]);

  const fullName = user?.first_name && user?.last_name 
    ? `${user.first_name} ${user.last_name}` 
    : user?.name || "Unknown";

  return (
    <Group gap="sm" wrap="nowrap">
      {user?.avatar_url ? (
        <Avatar src={user.avatar_url} size="sm" radius="xl" />
      ) : (
        <Avatar size="sm" radius="xl" color="purple">
          {fullName.charAt(0)}
        </Avatar>
      )}
      <Text size="sm" lineClamp={1}>
        {fullName}
      </Text>
    </Group>
  );
};

export default SignalOwnerCell;
